<template>
  <div class="copyright">
    <div class="compent-box">
      <h1 class="fs-xxxl text-center">软件著作权</h1>
      <div class="w-default">
        <swiper :options="swiperOption" class="swiper">
          <swiper-slide class="swiper-slide">
            <img src="../assets/img/Copyright/1.jpg" alt />
            <p>安信大数据平台[SC-BDID](v2.0)</p>
          </swiper-slide>
          <swiper-slide class="swiper-slide">
            <img src="../assets/img/Copyright/2.jpg" alt />
            <p>安信内容管理系统[SC-CMS](V1.0)</p>
          </swiper-slide>
          <swiper-slide class="swiper-slide">
            <img src="../assets/img/Copyright/3.jpg" alt />
            <p>安信数据集成平台[SC-DIP](V3.0)</p>
          </swiper-slide>
          <swiper-slide class="swiper-slide">
            <img src="../assets/img/Copyright/4.jpg" alt />
            <p>安信数据交换平台[SC-DICP-EXCHANGE](V1.0)</p>
          </swiper-slide>
          <swiper-slide class="swiper-slide">
            <img src="../assets/img/Copyright/5.jpg" alt />
            <p>安信四点半课管理系统V1.0</p>
          </swiper-slide>
          <swiper-slide class="swiper-slide">
            <img src="../assets/img/Copyright/6.jpg" alt />
            <p>安信物业管理系统V1.0</p>
          </swiper-slide>
          <swiper-slide class="swiper-slide">
            <img src="../assets/img/Copyright/7.jpg" alt />
            <p>安信校园驾驶舱系统V1.0</p>
          </swiper-slide>
          <swiper-slide class="swiper-slide">
            <img src="../assets/img/Copyright/8.jpg" alt />
            <p>安信一体化运维平台著作权</p>
          </swiper-slide>
          <swiper-slide class="swiper-slide">
            <img src="../assets/img/Copyright/9.jpg" alt />
            <p>安信智能导览系统V1.0</p>
          </swiper-slide>
          <swiper-slide class="swiper-slide">
            <img src="../assets/img/Copyright/10.jpg" alt />
            <p>病媒生物防制监管系统（SC-SOV）V1.0</p>
          </swiper-slide>
          <swiper-slide class="swiper-slide">
            <img src="../assets/img/Copyright/11.jpg" alt />
            <p>藏品数字化管理系统（SC-COS）V1.0</p>
          </swiper-slide>
          <swiper-slide class="swiper-slide">
            <img src="../assets/img/Copyright/12.jpg" alt />
            <p>藏品信息管理系统（SC-CIM）V1.0</p>
          </swiper-slide>
          <swiper-slide class="swiper-slide">
            <img src="../assets/img/Copyright/13.jpg" alt />
            <p>客流管理系统（SC-PFP）V1.0</p>
          </swiper-slide>
          <swiper-slide class="swiper-slide">
            <img src="../assets/img/Copyright/14.jpg" alt />
            <p>展览管理系统（SC-EMS）V1.0</p>
          </swiper-slide>
          <swiper-slide class="swiper-slide">
            <img src="../assets/img/Copyright/15.jpg" alt />
            <p>智慧校园开放平台软件[SC-CCE](V2.0)</p>
          </swiper-slide>
          <!-- Add Pagination -->
          <!-- <div class="swiper-pagination"></div> -->
        </swiper>
      </div>
    </div>
  </div>
</template>
<script>
import "swiper/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  components: {
    swiper
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 4,
        spaceBetween: 30,
        slidesPerGroup: 4,
        //自动轮播
        autoplay: {
          delay: 3000,
          //当用户滑动图片后继续自动轮播
          disableOnInteraction: false
        },
        loop: true,
        loopFillGroupWithBlank: true,
        /* pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        } */
      }
    };
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
.w-default{
  position: relative;
}
.copyright {
  h1 {
    margin-bottom: 40px;
  }
  .swiper-slide{
    img{
      width: 100%;
      height: 370px;
    }
    p{
      margin-top: 20px;
      text-align: center;
    }
  }
}
</style>